// <div data-controller="notes--draft">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";
import helpers from "@/utils/helpers";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "container" ];
  static classes = []
  static values = {
    editorData: Object,
    extId: String
  };

  initialize() {

  }

  get editorJsController() {
    // components--editor-js 는 editor 전용 Stimulus app(entrypoints/editor.js)에
    // 등록돼 있어 메인 app 의 this.application 으로는 조회되지 않는다.
    const form = document.getElementById("editorJsForm")
    if (!form) return null
    const editorApp = window.editorStimulusApp
    return (editorApp && editorApp.getControllerForElementAndIdentifier(form, "components--editor-js"))
      || this.application.getControllerForElementAndIdentifier(form, "components--editor-js")
  }

  listModalController(index) {
    return this.application.getControllerForElementAndIdentifier(document.getElementById("modal" + index), "components--modal")
  }

  recoverRepositoryData() {
    if (confirm("작성중이던 데이터를 덮어쓰고, 이 내용으로 복구 하시겠어요?")) {
      const editorJsController = this.editorJsController
      if (!editorJsController) {
        console.error("EditorJS controller를 찾을 수 없어 복구를 진행할 수 없습니다.")
        alert("에디터를 찾을 수 없어 복구할 수 없습니다. 페이지를 새로고침 후 다시 시도해주세요.")
        return
      }
      editorJsController.clearAndRenderDraft(this.editorDataValue);
      this.listModalController(this.extIdValue).hideModal();
    }
  }

  connect() {

  }

  disconnect() {

  }
}